
import vFooter from '../common/footer.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import LoadMore from 'vux/src/components/load-more/index.vue'

import {
recommendBuyDetail
} from '@/base/js/api'
export default {
name: 'app',
data() {
return {
accessToken:this._wxTool.getAccessToken(),
memberRecommendBuyId:'',
data:''
}
},
components: {
Actionsheet,
PopupPicker,
Scroller,
LoadMore,
vFooter
},
created() {
let param ={
memberRecommendBuyId:this.$route.query.memberRecommendBuyId,//状态0待审核1审核通过2无效3已成单4未成单
accessToken :this.accessToken
}
recommendBuyDetail(param).then(res=>{
if(res.code == 0){
console.log(res);
this.data = res.data.memberRecommendBuy
}else{
this.$vux.toast.text(res.msg, 'middle')
}
})
},
}



// WEBPACK FOOTER //
// ./src/pages/planDetail/planDetail.vue